import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG } from "@/data/content";
import { Reveal, SectionTag, TituloLineas, FotoRevelada } from "@/components/Reveal";

const EQUIPO = [
  { id: "carlos-quiroga", src: IMG.carlosQuiroga, nombre: "Carlos Quiroga Sivila", cargo: "Gerente General" },
  { id: "anna-rodriguez", src: IMG.annaRodriguez, nombre: "Anna Rodríguez", cargo: "Gerente de marketing y operaciones" },
  { id: "bernardo-quiroga", src: IMG.bernardoQuiroga, nombre: "Bernardo Quiroga", cargo: "Encargado de gestión y pilotaje" },
  { id: "augusto-languidey", src: IMG.augustoLanguidey, nombre: "Augusto Languidey", cargo: "Técnico en logística" },
  { id: "fernando-hurtado", src: IMG.fernandoHurtado, nombre: "Fernando Hurtado", cargo: "Encargado del servicio técnico y posventa" },
];

// Franja «Nosotros» de la portada: las fotos del equipo con nombre y cargo,
// una frase y el botón que lleva a la página /nosotros.
export default function Nosotros() {
  return (
    <section id="nosotros" className="scroll-mt-20 border-y border-hud bg-surface px-4 py-14 sm:px-8 sm:py-20 lg:px-12 lg:py-32">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <SectionTag>Nosotros</SectionTag>
          <TituloLineas
            lineas={["Una empresa boliviana,", "con los pies en el campo"]}
            className="mt-5 max-w-2xl font-display text-2xl font-bold uppercase leading-tight tracking-tight text-mist sm:text-3xl lg:text-4xl"
          />
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-smoke sm:text-base">
            Especialistas en drones agrícolas DJI Agriculture, con servicio desde 2024 en Santa Cruz, Beni y Cochabamba.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-testid="nosotros-franja-equipo">
          {EQUIPO.map((p, i) => (
            <Reveal key={p.id} delay={Math.min(0.3, i * 0.06)} data-testid={`person-card-${p.id}`}>
              <figure className="group relative overflow-hidden border border-hud transition-colors duration-300 hover:border-certero/50">
                <FotoRevelada src={p.src} alt={`${p.nombre}, ${p.cargo} de CERTERO SRL`} className="aspect-[4/5] w-full" />
                <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-[#060b12] via-[#060b12]/55 to-transparent" aria-hidden="true" />
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <p className="font-display text-sm font-bold uppercase leading-snug tracking-wide text-mist sm:text-base">{p.nombre}</p>
                  <p className="mt-1 font-mono text-[9px] uppercase leading-snug tracking-[0.2em] text-certero">{p.cargo}</p>
                </div>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-10">
          <Link
            data-testid="nosotros-btn-conocer"
            to="/nosotros"
            className="group inline-flex h-14 items-center gap-3 rounded-full bg-certero px-9 font-display text-sm font-bold uppercase tracking-[0.15em] text-ink transition-[background-color,transform] duration-300 hover:bg-[#4bc443] active:scale-95"
          >
            Conocer a CERTERO <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
